<!-- filepath: src/components/PageFooter.vue -->
<template>
  <footer class="text-white py-3" style="background-color: rgb(180, 192, 187);">
    <div class="container">
      <div class="w-100 w-md-75 mx-auto">
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-evenly gap-3">
          <span class="fs-5 flex-shrink-0" style="color: #22443E;">Een samenwerking tussen:</span>
          <img src="@/assets/img/midden_groningen_logo.png" alt="Midden-Groninge logo" class="rounded-1 flex-shrink-0" style="height:50px; max-width:100%;" />
          <img src="@/assets/img/bvv_logo.png" alt="Bureau voor Verduurzamen logo" class="rounded-1 flex-shrink-0" style="height:50px; max-width:100%;" />
          <img src="@/assets/img/nijbegun_logo_isolatie.png" alt="Nijbegun logo" class="rounded-1 flex-shrink-0" style="height:50px; max-width:100%;" />
        </div>
      </div>
    </div>
  </footer>
</template>